import { useLanguage } from "@/contexts/LanguageContext";

const Privacy = () => {
  const { t } = useLanguage();
  
  return (
      <div className="py-16">
        <section className="py-20 bg-muted">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
                {t('privacy.title')}
              </h1>
            </div>
          </div>
        </section>
  
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto prose prose-lg">
              <div className="bg-card p-8 rounded-2xl shadow-lg space-y-6">
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('privacy.collectTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('privacy.collectDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('privacy.useTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('privacy.useDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('privacy.protectTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('privacy.protectDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('privacy.shareTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('privacy.shareDesc')}
                  </p>
                </div>
  
                <div>
                  <h2 className="text-2xl font-bold text-foreground mb-4">{t('privacy.contactTitle')}</h2>
                  <p className="text-muted-foreground leading-relaxed">
                    {t('privacy.contactDesc')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
  
  export default Privacy;
  